import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//MYCOMPONENTS
import Loader       from "../Components/component_Loader";
import GoToLogin    from "../Components/component_GoToLogin";
import ErrorMessage from "../Components/component_MsgError";
//MATERIAL COMPONENTS
import AppBar       from "material-ui/AppBar";
import IconAccount  from "material-ui/svg-icons/action/account-circle";
//ACTION
import { getUserInfo } from "../Actions/Action_ServiceRequest_Home";
import { logout }      from "../Actions/Action_Authentication";
//LABELS
import { LABEL_PAGE_Company, LABEL_PAGE_Libra, LABEL_PAGE_CustomPrints, LABEL_PAGE_CustomPrintsA, LABEL_PAGE_Printer, LABEL_PAGE_CustomTables, LABEL_PAGE_CustomTablesA,
         LABEL_PAGE_CustomFields,LABEL_PAGE_CustomFieldsA, LABEL_PAGE_Librasm, LABEL_PAGE_Weigh, LABEL_Plant, LABEL_PAGE_Operators, LABEL_PAGE_Settings, LABEL_PAGE_Holding, LABEL_Logout,
         LABEL_Choose_Plant,LABEL_PAGE_Libras, LABEL_Payment, LABEL_PAGE_UpgradePro, LABEL_PAGE_UpgradeCloud } from "../Utils/Strings/Labels";
//UTILS
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROLES       from "../Utils/Roles_Types";
import * as ROUTE       from "../Utils/Strings/Route";
import { checkUserLanguage } from "../Utils/Check_Value.js";
//ROUTER
import createBrowserHistory from "history/createBrowserHistory";
//STYLE 
import "../CSS/style_Home.css";
//IMPORT ICON
import "../CSS/icon-font/icon-bilapp-complete/css/sg-bilapp.css";
import "../CSS/icon-font/icon-bilapp-complete/css/sg-bilapp-codes.css";
import "../CSS/icon-font/icon-bilapp-complete/css/sg-bilapp-embedded.css";

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

let history = createBrowserHistory();

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title : null,
      class : null
    }
  }

  //Richiamata alla
  componentDidMount() {
    this.props.dispatch(getUserInfo());
  }

  onMouseOver = (title) => {
    this.setState(
      {
        title : title,
        class : "slide-in" 
      }
    )
  };

  onMouseLeave= () => {
    this.setState(
      {
        title : null,
        class : "slide-out"
      }
    )
  };

  render() {
    const styles = {
      i: {
        background: "white",
        fontSize : "45px"
      }
    };
    
    console.log(this.props.userInfo);

    var scaduto  = this.props.userInfo && ( this.props.userInfo.Scadenza.Scaduto                  );
    var userFree = this.props.userInfo && ( this.props.userInfo.Role.ID === ROLES.ACCOUNT_FREE_ID );
    var userPro  = this.props.userInfo && ( this.props.userInfo.Role.ID === ROLES.ACCOUNT_PRO_ID  );
    var notProAndFree = !userFree && !userPro;
    var userRoleID = this.props.userInfo && this.props.userInfo.Role.ID;
    var labelUpgrade  = userFree ? LABEL_PAGE_UpgradePro[USERLANGUAGE] : LABEL_PAGE_UpgradeCloud[USERLANGUAGE];
    
    return <div className="page-container">
        
        <Loader isFetching={this.props.isFetching}/>
        <AppBar
            className="app-bar"
            title = { <div className="info">
                        <div className="username">{ this.props.userInfo ? this.props.userInfo.Username : "-" }</div>
                        <div className="sub-title-app-bar">{this.props.userInfo ? this.props.userInfo.Role.Nome : "-"}</div>
                      </div> }
            showMenuIconButton = {false}
            titleStyle = {{textTrasform: "uppercase"}}
          />
          {/*PAGE CONTAINER*/ 
          <div className="home-menu"> 
            <div className = "hm-container">
              <div className = "sg-hex-sub-row">
                  { !scaduto &&
                    <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Weigh) }}>
                      <i className="icon-receipt"       > </i><div className="hex-label">{LABEL_PAGE_Weigh[USERLANGUAGE]}</div>
                    </div>
                  }
                  { !scaduto &&
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Fields) }}>
                        <i className="icon-th-outline"  > </i><div className="hex-label">{LABEL_PAGE_CustomFieldsA[USERLANGUAGE]}</div>
                      </div>
                  } 
                  { !scaduto &&
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Tables)  }}>
                        <i className="icon-table"       > </i><div className="hex-label">{LABEL_PAGE_CustomTablesA[USERLANGUAGE]}</div>
                      </div>
                  }
                  
              </div>
              <div className = "sg-hex-row">
                  { !scaduto &&
                      <div id="hexagon"  onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Libras) }}>
                        <i className="icon-balance-scale" style={{marginRight: "15px"}}> </i><div className="hex-label">{LABEL_PAGE_Libras[USERLANGUAGE]}</div>
                      </div>
                  }
                  { !scaduto &&
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Plants) }}>
                        <i className="icon-building"      > </i><div className="hex-label">{LABEL_Plant[USERLANGUAGE]}</div>
                      </div>
                  }
                  { !scaduto && ( !notProAndFree || ( (userRoleID === ROLES.ADMINISTRATOR_IS_ID || userRoleID === ROLES.ADMINISTRATOR_HOLDING_ID) ) )  && 
                      <div id="hexagon"  onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Companies)  }}>
                        <i className="icon-building-1"  > </i><div className="hex-label">{LABEL_PAGE_Company[USERLANGUAGE]}</div>
                      </div>
                  }
                  { !scaduto && (userRoleID === ROLES.ADMINISTRATOR_IS_ID || userRoleID === ROLES.ADMINISTRATOR_HOLDING_ID) && 
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Operators)}}>
                        <i className="icon-users-yo"    > </i><div className="hex-label">{LABEL_PAGE_Operators[USERLANGUAGE]}</div>
                      </div>
                  }
                  { //Le aziende sono visualizzabili solo da amministratore IS e holding
                    notProAndFree && !scaduto && this.props.userInfo && (this.props.userInfo.Role.ID === ROLES.ADMINISTRATOR_IS_ID) && 
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Holding) }}>
                        <i className="icon-upload-cloud"    > </i><div className="hex-label">{LABEL_PAGE_Holding[USERLANGUAGE]}</div>
                      </div>
                  }
                  {
                    !notProAndFree && !scaduto && 
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Upgrade, {UIDR: this.props.userInfo.Role.ID}) }}>
                        <i className="icon-upload-cloud"    > </i><div className="hex-label">{userFree ? LABEL_PAGE_UpgradePro[USERLANGUAGE] : LABEL_PAGE_UpgradeCloud[USERLANGUAGE]}</div>
                      </div>
                  }
              </div>
              <div className = "sg-hex-sub-row">
                  {  !scaduto && ( !notProAndFree || ( (userRoleID === ROLES.ADMINISTRATOR_IS_ID || userRoleID === ROLES.ADMINISTRATOR_HOLDING_ID || userRoleID === ROLES.ADMINISTRATOR_AZIENDA_ID ) ) ) && 
                    <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Printers) }}>
                      <i className="icon-print"              > </i><div className="hex-label">{LABEL_PAGE_Printer[USERLANGUAGE]}</div>
                    </div>
                  }
                  { notProAndFree && scaduto && 
                      <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Settings) }}>
                        <i className="icon-cog"              > </i><div className="hex-label">{LABEL_Payment[USERLANGUAGE]}</div>
                      </div>
                  }
                  {
                    <div id="hexagon" onClick={() => { PAGESSWITCH.gotoPageWithParams(ROUTE.Settings) }}>
                      <i className="icon-cog"                > </i><div className="hex-label">{LABEL_PAGE_Settings[USERLANGUAGE]}</div>
                    </div>
                  }
                  {
                    <div id="hexagon" onClick={() => { this.props.dispatch(logout()) }}>
                      <i className="icon-exit-to-app-button" > </i><div className="hex-label">{LABEL_Logout[USERLANGUAGE]}</div>
                    </div>
                  }
                  
              </div>
            </div>
          </div>}
        </div>

  }
}

Home.propTypes = {
  dispatch: PropTypes.func.isRequired
};

/*
* Un operatore puo essere associato a piu aziende quindi eseguo la ricerca delle aziende a cui e' associato e se ce ne piu di una do la possibilita di selezionare all'operatore suj quale azienda vuole lavorare.
*/

function mapStateToProps(state) {
  const { homeReducer } = state;
  const { isFetching, isAuthenticated, userInfo, errorMessage } = homeReducer;
  return {
    isFetching,
    isAuthenticated,
    userInfo,
    errorMessage
  };
}

export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/Containers/Home.js